const TV_UA =
  /Roku|\bDVP-|SMART-TV|SmartTV|Web0S|Tizen|BRAVIA|VIDAA|HbbTV|CrKey|AppleTV|Apple TV|Viera|NetCast|OTT-CKT|TV Safari/i

export function isTvTextEntryHost(userAgent: string): boolean {
  return TV_UA.test(userAgent)
}

export function isRokuTextEntryHost(userAgent: string): boolean {
  return /Roku|\bDVP-/i.test(userAgent)
}
